function ArrowUp({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'}  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_8085_17)">
      <path d="M7 14L12 9L17 14H7Z" fill="black" fill-opacity="0.54"/>
      </g>
      <defs>
      <clipPath id="clip0_8085_17">
      <rect width=${dimensions || '24'} height=${dimensions || '24'} fill="white" transform="matrix(1 0 0 -1 0 24)"/>
      </clipPath>
      </defs>
    </svg>
  `;

  return baseXml;
}

export default ArrowUp;
